module.exports = __webpack_public_path__ + "img/allottee4_7-8-2021.a561d7d2.jpg";